import { Button, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { variants } from '../../../../variants/variants';
import UserAvatar from '../../../../common/UserAvatar';
import { Box } from '@mui/material';
import { ArrowRightAltRounded, EventAvailable, RateReviewRounded } from '@mui/icons-material';
import { colors } from '../../utility/status';
import { useTheme } from '@emotion/react';
import { format } from 'date-fns';

const CustomRow = ({ gift, handleOpenFeedback, result }) => {
  const id = gift._id;
  const user = gift.employeeDetails;
  const currentDesignation = gift.currentDesignation?.split(' - ')[0];
  const desiredDesignation = gift.desiredDesignation?.split(' - ')[0];
  const submitted = gift.submissionDate;
  const jury = gift[6];
  const juryMeeting = gift.juryMeetingDate;
  const theme = useTheme();

  return (
    <>
      <Stack direction={'row'} alignItems={'center'} sx={{ border: 0 }}>
        <UserAvatar src={user?.employeePhotoPath} />
        <Box mr={'auto'} ml={2}>
          <Typography sx={{ fontSize: variants.BODY }}>{user?.empName}</Typography>
          <Stack direction={'row'} alignItems={'center'} sx={{ mb: 0.5 }}>
            <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>
              {currentDesignation}
            </Typography>
            <ArrowRightAltRounded />
            <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>
              {desiredDesignation}
            </Typography>
          </Stack>
          <Typography sx={{ fontSize: variants.TINY }}>{format(new Date(submitted), 'PP')}</Typography>
        </Box>

        <Stack sx={{ ml: 'auto', alignItems: 'center' }}>
          {result === 'Completed' && (
            <Button
              size='small'
              startIcon={<RateReviewRounded fontSize='small' sx={{ color: colors.Pending }} />}
              sx={{
                mb: 1,
                color: colors.Pending,
                fontSize: variants.TINY,
              }}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenFeedback(id, gift);
              }}
            >
              feedback
            </Button>
          )}
          <Stack
            direction={'row'}
            alignItems={'center'}
            sx={{
              color: colors.Pass,
            }}
          >
            <EventAvailable fontSize='small' sx={{ mr: 1 }} />
            <Typography sx={{ fontSize: variants.TINY, textWrap: 'wrap' }}>
              {format(new Date(juryMeeting), 'PP')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      {/* <SwipeEdge drawerBleeding={0} /> */}
    </>
  );
};
export default CustomRow;
